(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
    .controller('AdminEditSettingsController', AdminEditSettingsController);

    function AdminEditSettingsController(
        $state,
        messenger,
        moment,
        lodash,
        apiClient,
        settingsCollection,
        settingsFields,
        elbSettings,
        module,
        fileTypeService,
        buildTabSettingFormTypes,
        validateTabSettings,
        modulesService
    ) {
        const vm = this;

        if (module && !elbSettings.getSetting(module).value) {
            $state.go('dashboard.user.dashboard');
        }

        vm.contractsModuleEnabled = modulesService.isEnabled('contracts_module');
        vm.auditsModuleEnabled = modulesService.isEnabled('audits_module');
        vm.tasksModuleEnabled = modulesService.isEnabled('tasks_module');

        vm.settingsCollection = settingsCollection;
        vm.settingsCollection.id = 1;

        vm.excludedFields = [];

        if (!vm.auditsModuleEnabled) {
            vm.excludedFields.push('general_audits_generate_ahead');
        }

        if (!vm.tasksModuleEnabled) {
            vm.excludedFields.push('general_tasks_generate_ahead');
        }

        vm.settings = loadSettings(filterSettings(settingsCollection.settings, vm.excludedFields));


        vm.settingFormTypes = buildTabSettingFormTypes(vm);
        vm.settingsForm = buildSettingsForm(settingsCollection.settings);
        vm.specialCaseFields = [
            'general_inactivate_users_enabled',
            'general_inactivate_users_days',
            'general_meridian_workflow',
            'general_meridian_compliance_documents_available'
        ];

        vm.settingsForm.id = 1;
        vm.update = updateAction;

        function filterSettings(settings, excludedFields) {
            return settings.filter(setting => !excludedFields.includes(setting.name));
        }

        function getElementValue(name)
        {
            const element = vm.settings[name];

            if (element) {
                return element.value;
            }

            return null;
        }

        function updateAction()
        {
            const updateActionMethod = function() {
                const requestData = {
                    settings: []
                };

                let settingsInvalid = false;

                if (typeof validateTabSettings === 'function') {
                    const isValid = validateTabSettings(vm);
                    if (isValid === false) {
                        return;
                    }
                }

                for (const key in vm.settingsForm) {
                    if (vm.settings[key]) {
                        const obj = vm.settingFormTypes[key];

                        if (obj.type === 'number') {
                            if (vm.settingsForm[key] % 1 !== 0 && vm.settingsForm[key] !== undefined) {
                                obj.options = { invalid: true };
                                settingsInvalid = true;
                                messenger.error('NO_DECIMAL_ALLOWED');
                                break;
                            }
                        }

                        const setting = vm.settings[key];
                        const settingFormType = vm.settingFormTypes[setting.name];

                        if (settingFormType.type === 'time') {
                            if (vm.settingsForm[key] === null) {
                                setting.value = null;
                            } else {
                                setting.value = moment(vm.settingsForm[key]).format('HH:mm');
                            }
                        } else if (settingFormType.type === 'file' || settingFormType.type === 'image-file-property') {
                            if (vm.settingsForm[key] && vm.settingsForm[key].href) {
                                setting.value = vm.settingsForm[key].href;
                            } else if (vm.settingsForm[key] && vm.settingsForm[key]._links && vm.settingsForm[key]._links.resource) {
                                setting.value = vm.settingsForm[key]._links.resource.href || null;
                            } else {
                                setting.value = null;
                            }
                        } else {
                            setting.value = vm.settingsForm[key];
                            if (key === 'file_allowed_types') {
                                const value = vm.settingsForm[key];
                                setting.value = fileTypeService.splitHeifHeic(value);
                            }
                        }
                        requestData.settings.push({name: setting.name, value:setting.value});
                    }
                }

                if (settingsInvalid !== true) {
                    apiClient.update(vm.settingsCollection.getLink('edit'), requestData).then(function (response) {
                        if (response) {
                            $state.go('^', {}, {reload: true}).then(function () {
                                messenger.success('SETTINGS_UPDATED');
                            });
                        } else {
                            messenger.error('REQUEST_ERROR');
                        }
                    });
                }
            }

            updateActionMethod();
        }

        function loadSettings(settingsArray) {
            const settings = {};

            for (const i in settingsFields) {
                const setting = lodash.find(settingsArray, { name: settingsFields[i] });
                if (setting !== undefined) {
                    settings[settingsFields[i]] = angular.copy(setting);
                }
            }

            return settings;
        }

        function buildSettingsForm() {
            const settingsForm = {};

            for (const i in settingsFields) {
                if (vm.settings[settingsFields[i]] === undefined) {
                    continue;
                }
                const settingFormType = vm.settingFormTypes[settingsFields[i]];
                const settingValue = getElementValue(settingsFields[i]);

                switch (settingFormType.type) {
                    case 'time':
                        settingsForm[settingsFields[i]] = buildTime(settingValue);
                        break;
                    case 'number':
                        settingsForm[settingsFields[i]] = parseInt(settingValue);
                        break;
                    case 'datetime':
                        settingsForm[settingsFields[i]] = (settingValue.length ? new Date(settingValue): null);
                        break;
                    case 'file':
                    case 'image-file-property':
                        if (settingValue) {
                            settingsForm[settingsFields[i]] = {
                                href: settingValue,
                                filename: vm.settings[settingsFields[i]] && vm.settings[settingsFields[i]].filename
                                    ? vm.settings[settingsFields[i]].filename
                                    : null
                            };
                        }
                        break;
                    case 'email':
                        settingsForm[settingsFields[i]] = settingValue.toString();
                        break;
                    default:
                        settingsForm[settingsFields[i]] = settingValue;
                }

            }

            return settingsForm;
        }

        function buildTime(time) {
            let date = new Date();

            if ((lodash.isEmpty(time)) || isNaN(parseInt(time.substring(0, 2))) || isNaN(parseInt(time.substring(3, 5)))) {
                date = null;
            } else {
                if (time) {
                    date.setHours(parseInt(time.substring(0, 2)));
                    date.setMinutes(parseInt(time.substring(3, 5)));
                }
                date.setSeconds(0);
                date.setMilliseconds(0);
            }

            return date;
        }
    }
})();
